import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, MessageCircle } from 'lucide-react';
import { GlowButton, GlassCard, SectionShell } from './LandingPrimitives';
import { trackLandingEvent } from './analytics';

const BottomCtaSection = () => {
  return (
    <SectionShell id="get-started" className="pb-10 md:pb-14">
      <GlassCard className="border border-ga-primary/30">
        <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
          <div>
            <h2 className="text-2xl font-bold text-ga-text-primary md:text-3xl">Ready to run your ground with clarity?</h2>
            <p className="mt-3 max-w-xl text-sm text-ga-text-muted md:text-base">
              Start managing bookings, staff, and payments in one place — or talk to us if you have questions first.
            </p>
          </div>
          <div className="flex shrink-0 flex-wrap gap-3">
            <GlowButton
              as={Link}
              to="/login"
              onClick={() => trackLandingEvent('bottom_get_started_click')}
            >
              Get started <ArrowRight className="ml-2 h-4 w-4" />
            </GlowButton>
            <GlowButton
              as={Link}
              to="/contact"
              variant="ghost"
              onClick={() => trackLandingEvent('bottom_talk_to_us_click')}
            >
              <MessageCircle className="mr-2 h-4 w-4" />
              Talk to us
            </GlowButton>
          </div>
        </div>
      </GlassCard>
    </SectionShell>
  );
};

export default BottomCtaSection;
